import styled from '@emotion/styled';

export const HeroImage = styled.img<{ $media?: string; $hiddenMedia: string[] }>`
  && {
    ${({ $media }) => ($media ? `display: none; @media ${$media} { display: block; }` : '')}
    ${({ $hiddenMedia }) => $hiddenMedia.map((media) => `@media ${media} { display: none; }`).join(' ')}
  }
`;
